<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">자료실관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>제목</p>
                <input type="text" placeholder="제목을 입력하세요" class="form_control" v-model="searchInfo.title">
              </li>
              <li>
                <p>작성일자</p>
                <Datepicker v-model="searchInfo.startDt" :defaultDate="searchInfo.startDt" :format="'YYYY-MM-DD'" />
                <span>~</span>
                <Datepicker v-model="searchInfo.endDt" :defaultDate="searchInfo.endDt" :format="'YYYY-MM-DD'"/>
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
              <div class="form_select"></div>
              <button class="btn btn_md btn_darkblue" @click="fn_move_reg_page">신규 등록</button>
            </div>
            <table class="list">
              <thead>
                <tr>
                    <th>No</th>
                    <th>작성일자</th>
                    <th>제목</th>
                    <th>노출여부</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="resourcesList.length == 0">
                    <td colspan="4"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in resourcesList" :key="index" @click="fn_move_dtl_page(item.resource_id)">
                  <td><span>{{ item.no ? item.no : index + 1 }}</span></td>
                  <td><span>{{ item.reg_dt }}</span></td>
                  <td class="al"><span>{{ item.title }}</span></td>
                  <td><span>{{ item.display_yn == 'Y' ? '노출' : '미노출' }}</span></td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo"  v-show="pagingShow"/>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import Pagination from "@/components/AdminPagination.vue"
  import Datepicker from '@/components/Datepicker.vue'
  import commonUtil from "@/mixin/commonUtil";

  export default {
    name: 'ResourcesMngt',
    components: {
      Pagination,
      Datepicker
    },
    mixins: [commonUtil],
    data() {
      return {
        searchInfo : {
          title : '',
          startDt : '',
          endDt : '',
          pageInfo : {
            page : 1,
            pageSize : 5,
            totPage : 0
          }
        },
        pagingShow : false,
        resourcesList: []
      }
    },
    created(){
      this.fn_search();
    },
    methods : {
        fn_move_reg_page(){
            this.$router.push("/admin/board/resourcesMngtReg");
        },
        fn_search(){
            axios
                .post("/api/admin/board/searchResources", this.searchInfo)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.resourcesList = res.data.resourceList;

                  console.log("@@@@ resourcesList : %o",this.resourcesList);

                    this.searchInfo.pageInfo.totPage = res.data.totCnt;

                    if(this.searchInfo.pageInfo.totPage > 0){
                        this.pagingShow = true;
                    }

                })
                .catch((err) => console.log(err));
        },
        fn_move_dtl_page(resourceId){

            this.$store.dispatch('resources/setResourceId', resourceId);
            this.$router.push("/admin/board/resourcesMngtDtl");
        }
    }
  }
</script>

<style scoped>
.search_filter li {
  min-width: 260px;
}
.search_filter li:last-child {
  width: auto;
  flex: 0 0 auto;
  margin-left: auto;
}
</style>